export default {
    configurationSite: {
        urlSite: '',
        urlSrtSite: '', /*delete*/
        urlSubdomain: '/',
    },
    donorPortalSettings: {
        dataCacheUpdate: '',
        findDonor: {
            value: 'all',
            label: 'Previous Donation # or Donor Id #'
        },
        dhq: {
            enable: false,
            location: 'https://efip.softcomputer.com/SoftDHQ/don/web/donsrq/dhq/',
            restUrl: 'https://efip.softcomputer.com/SoftDHQ/don/web/donsrq/donsrq/rest/DONSRQ/loginRestJson',
        },
        validRescheduleLink: false,
        passwordSettings: {
            numberPasswordAttempts: {
                enable: false,
                numberAttempts: 3,
            },
            randomDelay: {
                enable: false,
                minDelay: 2,
                maxDelay: 5,
            },
            passwordValidate: {
                minlength: 8,
                uppercase: true,
                lowercase: true,
                numbers: true,
                specialCharacters: false,
            }
        },
        captchaSettings: {
            recaptcha: {
                enable: '0',
                siteKey: '',
            },
        },
        seo: {
            uriFavicon: '',
            siteTitle: '',
            /*                rulesPageTitle: '', */
        },
        timeZone: "UTC",
        hideEmptyLocation: false,
        hideZeroProcedures: false,
        timeToRedirect: 10000,
    },
    siteCustomizationData: {
        hash: '',
        headerFooter: {
            address: 'TEST DELETE',
            phone: '#',
            logo: 'custom/themes/default/images/company_logo.png', /*logo SCC path to logo for server SCC*/
            copyright: '',
            showFooter: false,
            showCopyright: true,
            showFooterMenus: false,
            footerFontColor: '#FFF',
            footerBackgroundColor: '#000',
        },
        socialMenu: {
            socialMenuPage: {
                facebook: {
                    href: '',
                    mapForState: 'urlFacebookPage',
                    svg: '<svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">' +
                        '<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n' +
                        '<path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/>\n' +
                        '</svg>',
                },
                twitter: {
                    href: '',
                    mapForState: 'urlTwitterPage',
                    svg: '<svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">' +
                        '<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n' +
                        '<path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>\n' +
                        '</svg>',
                },
                youtube: {
                    icon: 'youtube',
                    href: '1',
                    mapForState: 'urlYouTubePage',
                    svg: '<svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">' +
                        '<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n' +
                        '<path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/>\n' +
                        '</svg>',
                },
                pinterest: {
                    href: '',
                    mapForState: 'urlPinterestPage',
                    svg: '<svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">' +
                        '<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->' +
                        '<path d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"/>' +
                        '</svg>',
                },
                tumblr: {
                    href: '',
                    mapForState: 'urlTumblrPage',
                    svg: '<svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n' +
                        '<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n' +
                        '<path d="M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1 .8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5 .9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"/>\n' +
                        '</svg>',
                },
                instagram: {
                    href: '',
                    mapForState: 'urlInstagramPage',
                    svg: '<svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n' +
                        '<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n' +
                        '<path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>' +
                        '</svg>',
                },
                linkedin: {
                    href: '',
                    mapForState: 'urlLinkedinPage',
                    svg: '<svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n' +
                        '<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n' +
                        '<path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/>\n' +
                        '</svg>',
                },
                vimeo: {
                    href: '',
                    mapForState: 'urlVimeoPage',
                    svg: '<svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n' +
                        '<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n' +
                        '<path d="M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"/>\n' +
                        '</svg>',
                }
            },
            urlFacebookPage: '',
            urlTwitterPage: '',
            urlYouTubePage: '',
            urlPinterestPage: '',
            urlTumblrPage: '',
            urlInstagramPage: '',
        },
        colorAndFonts: {
            colorBasicFont: '#000',
            basicFont: 'ProximaNW01-Reg',
            colorButton: '#c9c76d',
            colorButtonHover: '#000',
        },
        messages: {
            notFoundDonor: 'We apologize for the inconvenience. It looks like we are unable to verify your information. Please call us at \n$PhoneSupport\nand we will update your donor record and help you login for the first time. Or fill out the contact form on the Contact Us page, and we will call you back as soon as possible.',
            notFoundDonorForTemporaryDonorRegistration: 'Please call $PhoneSupport to schedule a donation appointment',
            notFoundDonationLocation: 'Please call $PhoneSupport to schedule a $Procedure donation appointment',
            notFoundEmail: 'We apologize for the inconvenience. It looks like we are unable to verify your information. You are receiving this error because:\n 1. If this is your first visit to our new site, and you have donated with us before, you will need to create a new account. Please go to: Login -> Create New Account\n2. We recently moved to a new software system and may need to update your information.\n',
            supportsPhone: 'If you need assistance, please call us at $PhoneSupport to schedule a donation appointment.',
            prevDonationPreTabName: '(Your recent donation may not be available for up to 24-48 hours.)',
            createNewAccount: 'You must have a $VerificationDonor to create an account. If you do not have a $VerificationDonor, click $Schedule to schedule an appointment to donate blood.',
            emailValidation: 'The Email is blank',
            uniqueEmailValidation: 'Entered Email address is used by several Donors in SoftRecruit. Please Contact Administrator for help.',
            loginUpperText: '',
            loginBottomText: '',
            unavailable: 'Unavailable',
            donLocListTitle: '',
        },
        appointmentsPage: {
            distanceOptions: {
                arrDistanceOptions: [
                    {
                        banner: "5 miles",
                        value: "5"
                    },
                    {
                        banner: "10 miles",
                        value: "10"
                    },
                    {
                        banner: "15 miles",
                        value: "15"
                    },
                    {
                        banner: "20 miles",
                        value: "20"
                    },
                    {
                        banner: "Show All",
                        value: "1000000000"
                    }
                ],
                distance: 1000000000,
            },
            colorAppointmentButton: '#BFEFA4',
            colorFontAppointmentButton: '#000',
            colorManegeButton: '#DAFAEC',
            colorFontManegeButton: '#000',
            colorEmptyButton: '#fff',
            colorFontEmptyButton: '#000',
        },
        profilePage: {
            messageOptIn: '',
            idDonorCard: '',
            donorCardTemplateId: '',
        },
        previousDonations: {
            arrCreateTab: '',
            lifeTimeLocationSettings: {
                doubleCalc: [],
                totalField: '',

            },

            arrNameConformityLabelColumn: {
                DONATIONS_BP: {name: 'donationsBp', label: 'Blood Pressure'},
                DONATIONS_DATE: {name: 'donationsDate', label: 'Date'},
                DONATIONS_HDL: {name: 'donationsHdl', label: 'HDL'},
                DONATIONS_ID: {name: 'donationsId', label: 'Donation ID'},
                DONATIONS_LDL: {name: 'donationsLdl', label: 'LBL'},
                DONATIONS_PROCEDURE: {name: 'donationsProcedure', label: 'Procedure'},
                DONATIONS_PROSTATE_ANTIGEN: {name: 'donationsProstateAntigen', label: 'Prostate Antigen'},
                DONATIONS_PULSE: {name: 'donationsPulse', label: 'Pulse'},
                DONATIONS_TOT_CHOLESTEROL: {name: 'donationsTotCholesterol', label: 'Tot Cholesterol'},
                DONOR_STATUS: {name: 'donationsStatus', label: 'Donor Status'},
                LOCATION: {name: 'Location', label: 'Donation Site'},
                OUTCOME_C: {name: 'Outcome', label: 'Outcome'},
                PLTCT: {name: 'pltct', label: 'PLTCT'},
                POINTS: {name: 'points', label: 'Points'},
            }
        },

        homePage: {
            sliderCss: {
                heightRelativelyWide: '35',
                colorBanner: '#fff',
                colorButtonHover: '#fff',
                colorTextButtonHover: '#000',
                showBorderSliderButton: false,
            },
            textBlocks: {
                leftTextBlockHeader: '',
                leftTextBlockBody: '',
                leftTextBlockLink: '',
                leftTextBlockLinkAddress: '',
                leftTextBlockButton: '',
                leftTextBlockButtonLink: '',
                rightTextBlockHeader: '',
                rightTextBlockBody: '',
                rightTextBlockLink: '',
                rightTextBlockLinkAddress: '',
                rightTextBlockButton: '',
                rightTextBlockButtonLink: '',
            },
            slider: []
        },
        contactUsPage: {
            contactUsPhone: '',
            contactUsAddress: '',
            contactUsMailTo: '',
        },
    },
    crmSettings: {
        required: {
            firstName: true,
            lastName: true,
            email: true,
            phoneMobile: true,
            dob: true,
        },
        editable: {
            dob: false,
            donorId: true,
            email: true,
            firstName: false,
            lastName: false,
            phoneHome: true,
            addressCity: true,
            addressCountry: true,
            addressPostalCode: true,
            addressState: true,
            addressStreet: true,
        },
        eligibilities: {
            PPH: "PPH",
            PPH2x: "2PPH",
            WB: "*WB",
            x2WB: "DAPH",
        },
        order: {
            PPH: "Platelet",
            PPH2x: "2xPlatelet",
            Time: "Time",
            WB: "Whole Blood",
            x2WB: "Double RBC",
        },
        softdonorCodes: {},
        geoSettings: {
            geoParams: {
                lang: 'en',
                unit: 'imperial',
                scale: 0.621371192,
                displayRuler: 'mi',
                labelDisplayRuler: 'miles',
            },
            geoUrl: "https://sxpmaps.softcomputer.com/osm5/maps",
        },
        sendEmail: {
            idUserPostman: '',
        },
        sendSms: {
            smsEnable: true,
            smsNumber: '',
        },
        phoneFormat: '',
        phoneFormats: {},
        launch: false,
    },
}
